export default "__VITE_ASSET__DyKRyAK2__"